import VueClamp from 'vue-clamp'
import Vue from 'vue'

Vue.component('VueClamp', VueClamp)
